export default {
  defaultProps: {
    underline: 'hover',
    color: 'inherit'
  },
}
